import { getPlanProjection } from "@/lib/api/plan";
import type { PlanProjection } from "@/lib/api/projection-types";
import { createProjectionStore } from "./createProjectionStore";

export const usePlanProjectionStore = createProjectionStore<
  PlanProjection,
  [date?: string]
>(getPlanProjection, [undefined]);
